import {post} from '@/utils/request';
import {smcanteenserver} from '@/utils/baseUrl';
// import{sse_url} from '@/utils/baseUrl';

//列表
export async function getList(params) {
    return post(smcanteenserver+'/balanceRecord/getList', params, true)
}
//用户
export async function selectWxUser(params) {
    return post(smcanteenserver+'/balanceRecord/selectWxUser', params, true)
}
//用户充值
export async function recharge(params) {
    return post(smcanteenserver+'/balanceRecord/recharge', params, true)
}
//用户明细
export async function getDetailList(params) {
    return post(smcanteenserver+'/balanceRecord/getDetailList', params, true)
}
//文件上传
export async function importRecharge(params) {
    return post(smcanteenserver+'/balanceRecord/importRecharge', params, false)
}